import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import TruckColorIcon from '../../../../../../../common/icons/icr_envio.svg';
import MotiveTitle from '../MotiveTitle';
import NotReceived from '../../../forms/notReceived/NotReceived';

const NotReceivedMobile = ({ ...props }) => {
  const {
    motiveId,
    orderId,
    sku,
    product,
    profile,
    type,
    validationStatus,
    validation,
    onData,
  } = props;

  return (
    <Box>
      <MotiveTitle
        icon={TruckColorIcon}
        title="Despacho y retiro"
        subtitle="No ha llegado mi producto"
        mobile
      />
      <NotReceived
        mobile
        motiveId={motiveId}
        orderId={orderId}
        sku={sku}
        product={product}
        profile={profile}
        type={type}
        validationStatus={validationStatus}
        validation={validation}
        onData={onData}
      />
    </Box>
  );
};

NotReceivedMobile.propTypes = {
  motiveId: PropTypes.string,
  orderId: PropTypes.string,
  sku: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  selfServiceStatus: PropTypes.string,
  type: PropTypes.string,
  validationStatus: PropTypes.string,
  validation: PropTypes.object,
  onData: PropTypes.func,
};

export default NotReceivedMobile;
